export default __webpack_public_path__ + "static/media/sendy.b0be703b.svg";